import { Component, OnInit } from "@angular/core";
import { SessionStateService } from "../../../core/services/session-state.service";
import { EnergyService } from "../../../entities/energy/energy.service";
import { HOUSE_COUNTRIES } from "../../../entities/houses/houses.constants";
import { GeneralService } from "../../services/general.service";

@Component({
  selector: "app-contacts",
  templateUrl: "./contacts.component.html",
  styleUrls: ["./contacts.component.scss"],
})
export class ContactsComponent implements OnInit {
  isSpainCountry: boolean;
  customerServiceNumber: string;

  private _serviceProvider: string = "";

  constructor(
    private sessionStateService: SessionStateService,
    private generalService: GeneralService
  ) {}

  ngOnInit() {
    this.customerServiceNumber = this.generalService.getCustomerSupportNumber();
    const house = this.sessionStateService.getHouse();
    this._serviceProvider = house.serviceProvider;
    console.log(this._serviceProvider)
    this.isSpainCountry = house.country === HOUSE_COUNTRIES.SPAIN;
  }

  get serviceProvider(): string {
    return this._serviceProvider;
  }

  getInfoLink() {
    const lang = this.sessionStateService.get("language");
    if (this.isSpainCountry) {
      if (this._serviceProvider === "ES") {
        window.open("https://www.edpenergia.es/es/hogares/app-edp-solar/");
      }

      if (this.serviceProvider === "ES-TOTAL") {
        window.open("http://www.totalenergies.es");
      }
    } else {
      if (this.serviceProvider === "ES-TOTAL") {
        window.open("http://www.totalenergies.es");
      }
      else if (this.serviceProvider === "ES") {
        window.open("https://www.edpenergia.es/es/hogares/app-edp-solar/");
      }
      else if (this.serviceProvider === "PT") {
        window.open("https://www.edp.pt/particulares/servicos/edp-solar/");
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/contacts/contacts.component.ts